
import { createLabel } from "../utills";
import { useCallback, useContext } from "react";
import { TransAndConfigContext } from "../context/ConfigAndTranslationContext";

const useText = () => {
 const {langData={}} = useContext(TransAndConfigContext) ?? {};

  const getText = useCallback((key, parentKey, ...args) => {
    const label = langData?.[parentKey]?.[key] ?? langData?.[key]
    if (!label) {
      return key;
    }
    return args.length > 0 ? createLabel(label, args) : label;
  },[langData])

  return { getText }
}

export default useText